var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.timeoutClass},[_vm._v(" "+_vm._s(_vm.countdown)),(_vm.timeout)?_c('span',[_vm._v("（超时）")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }